import React from 'react'
import {Link} from "react-router-dom"
function HomeNavbar() {
  return (
    <div className='home-navbar-bg'>

<div className='home-navbar-main'>

 <div className='home-navbar-left-col'>BhumuCompany <span>Workspace</span> </div>
 <div className='home-navbar-right-col'><Link to="/login"> Continue  <i className="fa-regular fa-circle-right"></i> </Link></div>
</div>
    </div>
  )
}

export default HomeNavbar